import { baseEnvironment } from "./environment.base";

export const environment = {
  ...baseEnvironment,
  production: false,

  // MSAL
  msalConfig: {
    auth: {
      clientId: "f2b4c3fc-93fc-4b16-a4ba-a32578079559",
      authority: "https://rocktopextid.ciamlogin.com/",
      knownAuthorities: ["rocktopextid.ciamlogin.com"],
    },
  },
  apiConfig: [
    {
      scopes: ["api://351ab99e-f931-4a88-90ca-b1d99ee0314d/user_impersonation"],
      uri: "/api",
    },
  ],
  powerBiDashboards: {
    slaCompliance: "https://app.powerbi.com/reportEmbed?reportId=2916b0b0-de10-45c4-96e0-672a156de1ee&autoAuth=true&ctid=92da63ac-9ebb-45cc-aa0a-556751a83078",
    volumesRevenue: "https://app.powerbi.com/reportEmbed?reportId=79c5c5e4-4a0c-4abe-abd3-5303160aa8cd&autoAuth=true&ctid=92da63ac-9ebb-45cc-aa0a-556751a83078"
  }
};
